// export const backend_url = "http://52.66.180.51:8000"
// export const backend_api = "http://52.66.180.51:8000/api/v1/"
export const backend_url = "https://api.lexmom.com";
export const backend_api = "https://api.lexmom.com/api/v1/";
